import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/Cartcontext'; // Keep this at top

// Import all components...
import Adminlogin from './adminpages/Adlog/Adlog';
import Adminregister from './adminpages/Adregist/Adminregister';
import AdminHome from './adminpages/AdminHome/AdminHome';
import AddedProducts from './adminpages/AddedProducts/AddedProducts';
import AddProducts from './adminpages/Adpduld/Adpduld';
import AdminForgotPass from './adminpages/Forgotpass/Adminforgotpass';
import ResetPass from './adminpages/Resetpass/Resetpass';
import AdminSettings from './adminpages/AdminSettings/AdminSettings';
import AdminRoute from './AdminRoute';
import ProtectedRoute from './ProtectedRoute';

import Login from './userpages/Login/Login';
import Home from './userpages/Home/Home';
import Mycart from './userpages/Mycart/Mycart';
import Buynow from './userpages/Buynow/Buynow';
import Buysamp from './userpages/Buysamp/Buysamp';
import PaymentSuccess from './userpages/PaymentSuccess/PaymentSuccess';
import PaymentFailure from './userpages/PaymentFailure/PaymentFailure';
import PaymentPage from './userpages/PaymentPage/PaymentPage';
import AboutUs from './userpages/Aboutus/Aboutus';
import ContactUs from './userpages/ContactUs/ContactUs';
import OurProducts from './userpages/OurProducts/OurProducts';
import Siteusers from './adminpages/Siteusers/Siteusers';
import Myorders from './userpages/Myorders/Myorders';
import UserRegistration from './userpages/Registration/Userregistration';
import UserSettings from './userpages/UserSettings/UserSettings';
import DeletedOrder from './adminpages/DeletedOrder/DeletedOrder';
import Testingpages from './adminpages/Testingpages/Testingpages';
import UserForgotpass from './userpages/UserForgotpass/UserForgotpass';
import UserResetpass from './userpages/UserResetpass/UserResetpass';
import SiteAdmins from './adminpages/SiteAdmins/SiteAdmins';
import Supplements from './userpages/Supplements/Supplements';

const App = () => {
  return (
    <Router>
      <CartProvider>
        <Routes>
          {/* Admin Routes */}
           <Route path="/admin/0083/home" element={<AdminRoute><AdminHome /></AdminRoute>} />
         <Route path="/admin/added-products" element={<AdminRoute><AddedProducts /></AdminRoute>} />
         <Route path="/admin/uploadproducts" element={<AdminRoute><AddProducts /></AdminRoute>} />
         <Route path="/admin/customers" element={<AdminRoute><Siteusers /></AdminRoute>} />
         <Route path="/admin/deleted-orders" element={<AdminRoute><DeletedOrder /></AdminRoute>} />
         <Route path="/0083/adminsettings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
         <Route path="/0083/siteadmins" element={<AdminRoute><SiteAdmins /></AdminRoute>} />
         <Route path="/admin/0083/login" element={<Adminlogin />} />
         <Route path="/0083" element={<AdminRoute><Adminregister /> </AdminRoute>} />
         <Route path="/admin/0083/forgot-password" element={<AdminForgotPass />} />
         <Route path="/admin/reset-password/:token" element={<ResetPass />} />

          
          {/* User Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Navigate to="/" replace />} />
          <Route path="/shreeohm/login" element={<Login />} />
          <Route path="/buynow/:ids" element={<Buynow />} />
          <Route path="/buynow/" element={<Buysamp />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />
          <Route path="/paymentpage" element={<PaymentPage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/about" element={<Navigate to="/about-us" replace />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/ourproducts" element={<OurProducts />} />
          <Route path="/shreeohm/registration" element={<UserRegistration />} />
          <Route path="/testing" element={<Testingpages />} />
          <Route path="/forgot-password" element={<UserForgotpass />} />
          <Route path="/reset-password/:token" element={<UserResetpass />} />
          <Route path="/Supplements" element={<Supplements />} />
          <Route path="/mycart" element={<ProtectedRoute><Mycart /></ProtectedRoute>} />
          <Route path="/my-orders" element={<ProtectedRoute><Myorders /></ProtectedRoute>} />
          <Route path="/shreeohm/settings" element={<ProtectedRoute><UserSettings /></ProtectedRoute>} />
          
        </Routes>
      </CartProvider>
    </Router>
  );
};

export default App;
